import request from '@/utils/request';
import { getUrlByGeneralInYinyitong } from '@/utils/defaultParameter';

const serviceName = 'datasync-dataviewsimulator';
const controllerName = 'yinyitong';
/**
 * 身份证获取卡号
 * IdCardNo  string  身份证
 * eventid      string   事件id
 */
export function obtainingIDCardNumber(data) {
  const interfaceName = 'obtainingIDCardNumber';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}

/**
 * 获取患者信息
 * InPatientNo  string  就诊卡
 * eventid      string   事件id
 */
export function patientInformationInquiry(data) {
  const interfaceName = 'patientInformationInquiry';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}

/**
 * 门诊缴费记录查询
 * InPatientNo  string  就诊卡
 * beginDate    Date    开始时间(时间戳)
 * endDate      Date    结束时间(时间戳)
 * eventid      string   事件id
 */
export function paymented(data) {
  const interfaceName = 'paymented/bills/query';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}

/**
 * 门诊缴费退费
 * Body 为门诊缴费记录接口返回的单条记录
 */
export function paymentedCancellation(data) {
  const interfaceName = 'paymented/bills/cancellation';
  const url = getUrlByGeneralInYinyitong(serviceName, controllerName, interfaceName);
  return request({
    url,
    method: 'post',
    data
  });
}
